import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "ride"
const RideIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M14.131 7.5C15.126 7.5 16.081 7.895 16.783 8.599L18.74 10.554 22.017 11.15C22.73 11.28 23.25 11.901 23.25 12.626V13.217L23.227 13.307 22.619 15.739C22.452 16.407 21.85 16.875 21.163 16.875H19.78C19.305 17.555 18.517 18 17.625 18S15.945 17.555 15.471 16.875H11.904C11.43 17.555 10.642 18 9.75 18S8.07 17.555 7.596 16.875H5.982C4.92 16.875 4.195 15.803 4.589 14.818L5.45 12.668C5.638 12.197 5.92 11.768 6.28 11.408L6.439 11.249 6.939 9H6.749C6.335 9 6 8.664 6 8.25S6.335 7.5 6.75 7.5zM9.75 14.25C9.129 14.25 8.625 14.754 8.625 15.375S9.129 16.5 9.75 16.5 10.875 15.996 10.875 15.375 10.371 14.25 9.75 14.25M17.625 14.25C17.004 14.25 16.5 14.754 16.5 15.375S17.004 16.5 17.625 16.5 18.75 15.996 18.75 15.375 18.246 14.25 17.625 14.25M8.054 10.898C8.38 10.978 8.624 11.273 8.624 11.625 8.624 12.039 8.288 12.375 7.874 12.375H7.436L7.34 12.47C7.125 12.686 6.955 12.943 6.842 13.225L5.982 15.375H7.125C7.125 13.925 8.3 12.75 9.75 12.75S12.375 13.925 12.375 15.375H15C15 13.925 16.175 12.75 17.625 12.75S20.25 13.925 20.25 15.375H21.163L21.75 13.033V12.626L18.31 12H14.913C14.009 12 13.168 11.534 12.688 10.767L11.584 9H8.476zM13.959 9.97C14.165 10.3 14.526 10.5 14.914 10.5H16.564L15.723 9.66C15.3 9.236 14.728 9 14.13 9H13.352z"
            clipRule="evenodd"
          />
          <path d="M3.75 14.25C3.75 15.078 3.078 15.75 2.25 15.75H1.125V14.25zM5.25 10.875C5.25 11.703 4.578 12.375 3.75 12.375H1.125V10.875zM5.25 7.5C5.25 8.328 4.578 9 3.75 9H1.5V7.5z" />
        </svg>
      }
    </span>
  )
}
export default RideIcon
